import axios from "axios";
import store from '../store'

axios.interceptors.request.use(config => {
    config.headers.locale = localStorage.getItem('locale');
    const token = localStorage.getItem('token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;

        const tokenInfo = JSON.parse(atob(token.split('.')[1]));
        const expTokenTime = tokenInfo.exp * 1000;
        const date = new Date().getTime();
        const timeToRefreshToken = window.entityCabinetSettings.tokenRefreshTime;

        if (expTokenTime - date <= timeToRefreshToken) {
            store.dispatch('refreshToken');
        }
    }

    return config;
});

axios.interceptors.response.use(function(response) {
    return response;
}, async function(error) {
    if (error?.response?.status === 401) {
        await store.dispatch('purgeAuth');
    }
    await store.dispatch('setError', error.response.data.message || 'Ошибка сервиса');
});

export default axios;